// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"0f835627","707":"a4f1f6d9","995":"941a38f4"}[chunkId] + ".chunk.js";
};